<template>
  <div>
    <svg x="0px" y="0px" viewBox="0 0 90 90">
      <rect class="st0" width="90" height="90" />
      <circle class="st1" cx="45" cy="45" r="40" />
      <text class="circle-chart-percent" x="20.91549431" y="40.5" font-size="8">
        {{ time }}
      </text>
      <path class="st2" :d="pathProgess" />
      <circle class="st3" cx="45" cy="5" r="3" />
    </svg>
  </div>
</template>

<script>
const moment = window.moment;

export default {
  name: "timer",
  data() {
    return {
      date: moment(this.timeP * 60 * 1000),
      pathProgess: "",
      pauseState: false
    };
  },
  computed: {
    time: function() {
      if (this.date._i >= 3600000) {
        return this.date.format("H:mm:ss");
      }
      return this.date.format("mm:ss");
    }
  },
  watch: {
    start(n, o) {
      if (n && !o) {
        this.onStart();
      }
    },
    timeP(n, o) {
      if (n && n !== o) {
        this.date = moment(n * 60 * 1000);
      }
    },
    pause(n, o) {
      if (n && !o) {
        this.pauseState = true;
      } else if (!n && o) {
        this.pauseState = false;
      }
    }
  },
  methods: {
    onStart() {
      let maxValue = this.date.diff(moment(0), "seconds"); //total seconds
      var timer = setInterval(() => {
        if (!this.pause) {
          this.date = moment(this.date.subtract(1, "seconds"));
          let curValue = this.date.diff(moment(0), "seconds"); // current seconds
          this.pathProgess = this.describeArc(
            45,
            45,
            40,
            0,
            ((maxValue - curValue) * 360) / maxValue
          );
          if (this.date.diff(moment(0)) === 0) {
            clearInterval(timer);
            this.$emit("done");
          }
        }
      }, 1000);
    },
    //copy from https://stackoverflow.com/a/18473154/5665870
    polarToCartesian: function(centerX, centerY, radius, angleInDegrees) {
      var angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180.0;

      return {
        x: centerX + radius * Math.cos(angleInRadians),
        y: centerY + radius * Math.sin(angleInRadians)
      };
    },
    //copy from https://stackoverflow.com/a/18473154/5665870
    describeArc: function(x, y, radius, startAngle, endAngle) {
      var start = this.polarToCartesian(x, y, radius, endAngle);
      var end = this.polarToCartesian(x, y, radius, startAngle);

      var largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";

      var d = [
        "M",
        start.x,
        start.y,
        "A",
        radius,
        radius,
        0,
        largeArcFlag,
        0,
        end.x,
        end.y
      ].join(" ");

      return d;
    }
  },
  props: {
    timeP: {
      type: Number,
      // required: true,
      default: 1
    },
    start: {
      type: Boolean
    },
    pause: {
      type: Boolean
    }
  }
};
</script>

<style scoped>
.st0 {
  fill: #ffffff;
}
.st1 {
  fill: none;
  stroke: #b5b5b5;
  stroke-miterlimit: 10;
}
.st2 {
  fill: none;
  stroke: #408eff;
  stroke-linecap: round;
  stroke-miterlimit: 10;
}
.st3 {
  fill: #408eff;
}
</style>
